<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<section class="car__rental" id="rental-policies">
    <div class="car__rental__content container py-4">
        <div class="car__rental__content__info d-none d-md-grid">
            <div class="car__rental__content__info__left">
                <div class="car__rental__content__info__head">
                    <div class="car__rental__content__info__left__top">
                        <h2
                            class="car__rental__content__info__left__top__title pt-1 pb-3"
                        >
                            {{
                                'fe_details_step5_car_rental_policy_title'
                                    | translate
                            }}
                        </h2>
                    </div>
                    <a
                        class="my-3 d-inline-block"
                        [routerLink]="
                            'questions/terms-and-conditions' | formatUrl
                        "
                        >{{
                            'fe_details_step5_car_rental_policy_terms'
                                | translate
                        }}</a
                    >
                </div>
                <div class="car__rental__content__info__body">
                    <div *ngIf="policies.length === 0; else content">
                        <div
                            class="car__rental__content__info__left__list"
                            *ngFor="let _ of placeholderItems"
                        >
                            <div
                                class="car__rental__content__info__left__list__content p-2 d-flex flex-row justify-content-between align-items-center"
                            >
                                <p
                                    class="car__rental__content__info__left__list__content__text placeholder placeholder-wave w-50"
                                >
                                    Placeholder text
                                </p>
                                <img
                                    class="car__rental__content__info__left__list__content__icon ms-2"
                                    [src]="'images/chevron-alt-left.svg' | cdn"
                                    alt="Toggle info icon"
                                />
                            </div>
                        </div>
                    </div>
                    <ng-template #content>
                        <div
                            class="car__rental__content__info__left__list"
                            *ngFor="let policy of policies"
                        >
                            <div
                                class="car__rental__content__info__left__list__content p-2 d-flex flex-row justify-content-between align-items-center"
                                [ngClass]="{
                                    toggled: selectedPolicyId === policy.id
                                }"
                                (click)="toggleInfo(policy.id)"
                            >
                                <p
                                    class="car__rental__content__info__left__list__content__text"
                                >
                                    {{ policy.text }}
                                </p>
                                <img
                                    class="car__rental__content__info__left__list__content__icon ms-2"
                                    [src]="'images/chevron-alt-left.svg' | cdn"
                                    alt="Toggle info icon"
                                />
                            </div>
                        </div>
                    </ng-template>
                    <div
                        class="car__rental__content__info__left__question mt-3 d-flex flex-row align-items-center"
                    >
                        <img
                            class="car__rental__content__info__left__question__icon me-1"
                            [src]="'images/question-rectangle.svg' | cdn"
                            alt="Question icon"
                        />
                        <p
                            class="car__rental__content__info__left__question__text"
                        >
                            {{
                                'fe_details_step5_car_rental_policy_cant_find'
                                    | translate
                            }}
                        </p>
                    </div>
                    <a
                        class="mt-1 d-inline-block"
                        [routerLink]="'questions' | formatUrl"
                        >{{
                            'fe_details_step5_car_rental_policy_href_faq'
                                | translate
                        }}</a
                    >
                </div>
            </div>
            <div class="car__rental__content__info__right">
                <div
                    class="car__rental__content__info__right__image d-flex flex-column justify-content-center align-items-center"
                    *ngIf="!selectedPolicyId"
                >
                    <img [src]="'images/Branch.svg' | cdn" alt="Branch icon" />
                </div>
                <div
                    class="car__rental__content__info__right__info d-flex flex-row pt-4"
                    *ngIf="selectedPolicyId"
                >
                    <p [innerHTML]="getPolicyInfo(selectedPolicyId)"></p>
                </div>
            </div>
        </div>
        <div class="car__rental__content__info__mobile col-12 d-md-none">
            <div class="car__rental__content__info__left__top">
                <h2
                    class="car__rental__content__info__left__top__title pt-1 pb-2"
                >
                    {{ 'fe_details_step5_car_rental_policy_title' | translate }}
                </h2>
            </div>
            <div class="mb-2"></div>
            <a
                class="car__rental__content__info__mobile__terms"
                [routerLink]="'questions/terms-and-conditions' | formatUrl"
                >{{ 'fe_details_step5_car_rental_policy_terms' | translate }}</a
            >
            <div class="mt-3"></div>
            <div *ngIf="policies.length === 0; else contentMobile">
                <div
                    class="car__rental__content__info__left__list"
                    *ngFor="let _ of placeholderItems"
                >
                    <div
                        class="car__rental__content__info__left__list__content p-2 d-flex flex-row justify-content-between align-items-center"
                    >
                        <p
                            class="car__rental__content__info__left__list__content__text placeholder placeholder-wave w-75"
                        >
                            Placeholder text
                        </p>
                        <img
                            class="car__rental__content__info__left__list__content__icon ms-2"
                            [src]="'images/chevron-alt-left.svg' | cdn"
                            alt="Toggle info icon"
                        />
                    </div>
                </div>
            </div>
            <ng-template #contentMobile>
                <div
                    class="car__rental__content__info__left__list"
                    *ngFor="let policy of policies"
                >
                    <div
                        class="car__rental__content__info__left__list__content p-2 d-flex flex-row justify-content-between align-items-center"
                        [ngClass]="{ toggled: selectedPolicyId === policy.id }"
                        (click)="toggleInfo(policy.id)"
                    >
                        <p
                            class="car__rental__content__info__left__list__content__text"
                        >
                            {{ policy.text }}
                        </p>
                        <img
                            class="car__rental__content__info__left__list__content__icon ms-2"
                            [src]="'images/chevron-alt-left.svg' | cdn"
                            alt="Toggle info icon"
                        />
                    </div>
                    <div
                        class="car__rental__content__info__left__list__details px-2 pt-2"
                        *ngIf="selectedPolicyId === policy.id"
                    >
                        <p
                            [innerHTML]="getPolicyInfo(policy.id) | noSanitize"
                        ></p>
                    </div>
                </div>
            </ng-template>
            <div
                class="car__rental__content__info__left__question mt-3 d-flex flex-row align-items-center"
            >
                <img
                    class="car__rental__content__info__left__question__icon me-1"
                    [src]="'images/question-rectangle.svg' | cdn"
                    alt="Question icon"
                />
                <p class="car__rental__content__info__left__question__text">
                    {{
                        'fe_details_step5_car_rental_policy_cant_find'
                            | translate
                    }}
                </p>
            </div>
            <a
                class="mt-1 car__rental__content__info__mobile__conditions"
                [routerLink]="'questions' | formatUrl"
                >{{
                    'fe_details_step5_car_rental_policy_href_faq' | translate
                }}</a
            >
        </div>
    </div>
</section>
